class ReadMore {
    constructor(el) {
        this.readMore = el;
        this.readMoreButton = el.querySelector('.read-more__button');
        this.attachListeners();
    }

    attachListeners() {
        if(this.readMoreButton) {
            this.readMoreButton.addEventListener('click', () => this.toggleContent());
        }
    }

    toggleContent() {
        const summary = this.readMore.querySelector('.read-more__summary');
        summary.classList.toggle('-open');
        this.readMoreButton.classList.toggle('-open');
    }
}

export default el => new ReadMore(el);
